module.exports = __webpack_public_path__ + "img/barkat.6c3f584.png";